import { produce } from 'immer';
import { UPDATE_PROFILE_USER, UPDATE_SETTINGS_FAILURE, UPDATE_SETTINGS_SUCCESS } from '../actions';
import { FieldTypes } from '../helpers/constants';
import { convertFieldFormatToMoment } from '../helpers/DateTimeUtility';
import { GET_PROFILE_REQUEST, GET_PROFILE_FAILURE, GET_PROFILE_SUCCESS, UPDATE_PROFILE_SIGNATURE } from './actions';
import { ProfileAction, ProfilePayload, ProfileState } from './profile-types';

export default function profile(existingState: ProfileState = {}, action: ProfileAction) {
  if (!action) {
    return existingState;
  }

  return produce(existingState, (state: ProfileState) => {
    const { type, payload } = action;

    switch (type) {
      case GET_PROFILE_REQUEST:
        return { ...state, ...payload };

      case UPDATE_SETTINGS_SUCCESS:
      case UPDATE_SETTINGS_FAILURE:
        state.settings = { ...state.settings, ...payload };
        state.independentUser = { ...state.independentUser, ...payload };
        return;

      case GET_PROFILE_SUCCESS:
        return setDateFormats(state, payload);

      case GET_PROFILE_FAILURE:
        return { ...state, ...payload, error: true };

      case UPDATE_PROFILE_USER:
        state.user = { ...state.user, ...payload };
        state.user.fullName = (state.user.firstName + ' ' + state.user.lastName).trim();
        state.user.name = state.user.firstName || state.user.lastName;

        state.independentUser = { ...state.independentUser, ...payload };
        state.independentUser.fullName = (state.independentUser.firstName + ' ' + state.independentUser.lastName).trim();
        state.independentUser.name = state.independentUser.firstName || state.independentUser.lastName;
        return;

      case UPDATE_PROFILE_SIGNATURE:
        state.savedSignatures = { ...state.savedSignatures, [action.fieldType === FieldTypes.eSignature ? 'signature' : 'initials']: payload };
        return;

      default:
        return state;
    }
  });
}

function setDateFormats(state: ProfileState, payload: ProfilePayload) {
  const newState: ProfileState = { ...state, ...payload, loaded: true, error: false };

  newState.rawDateFormat = {
    shortTime: newState.dateFormat?.shortTime as string,
    shortDate: newState.dateFormat?.shortDate as string,
    dateTime: newState.dateFormat?.dateTime as string
  };

  newState.dateFormat = {
    shortTime: convertFieldFormatToMoment(newState.dateFormat?.shortTime),
    shortDate: convertFieldFormatToMoment(newState.dateFormat?.shortDate)
  };

  return newState;
}
